 export class SnackbarData{
  public accion!: string
  public mensaje!: string
  public link!: string
  public icono!: string
  public nombreLink: string = ""
}
